import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RvoVerblijfPlaats } from './rvo-animal.models';
import {
  aanvoerStatus,
  afvoerStatus,
  bedrijfstypeLabel,
  formatRvoDisplayDate,
  formatVerblijfAddress,
  missingDestinationAanvoer,
  sortVerblijfPlaatsenNewestFirst,
  VerblijfAanvoerStatus,
  VerblijfAfvoerStatus,
} from './animal-info.utils';

interface TimelineEntry {
  plaats: RvoVerblijfPlaats;
  index: number;
  aanvoer: VerblijfAanvoerStatus;
  afvoer: VerblijfAfvoerStatus;
}

@Component({
  selector: 'tcc-mono-rvo-verblijfplaatsen-timeline',
  templateUrl: './rvo-verblijfplaatsen-timeline.component.html',
  styleUrls: ['./rvo-verblijfplaatsen-timeline.component.scss']
})
export class RvoVerblijfplaatsenTimelineComponent {
  @Input() public places: RvoVerblijfPlaats[] = [];
  @Input() public dierEinddatum: string | null = null;
  @Input() public dierRedenEinde: string | null = null;

  @Output() public mapClicked = new EventEmitter<RvoVerblijfPlaats | string>();

  protected readonly bedrijfstypeLabel = bedrijfstypeLabel;
  protected readonly formatRvoDisplayDate = formatRvoDisplayDate;

  public get missingDestination() {
    return missingDestinationAanvoer(
      this.places ?? [],
      this.dierEinddatum,
      this.dierRedenEinde,
    );
  }

  public get sortedPlaces(): TimelineEntry[] {
    return sortVerblijfPlaatsenNewestFirst(this.places ?? []).map((plaats, index) => ({
      plaats,
      index,
      aanvoer: aanvoerStatus(plaats),
      afvoer: afvoerStatus(plaats, index),
    }));
  }

  public entryTrack(_index: number, entry: TimelineEntry): string {
    return `${entry.plaats.meldingeenheid ?? 'unknown'}-${entry.index}`;
  }

  public openMap(plaatsOrUbn: RvoVerblijfPlaats | string): void {
    this.mapClicked.emit(plaatsOrUbn);
  }

  public afvoerClass(status: VerblijfAfvoerStatus): string {
    switch (status) {
      case 'missing':
        return 'status--missing';
      case 'on_location':
        return 'status--present';
      default:
        return '';
    }
  }

  public aanvoerClass(status: VerblijfAanvoerStatus): string {
    return status === 'missing' ? 'status--missing' : '';
  }

  public afvoerLabel(status: VerblijfAfvoerStatus, plaats: RvoVerblijfPlaats): string {
    if (status === 'ok') {
      return formatRvoDisplayDate(plaats.afvoerDatumME);
    }
    if (status === 'on_location') {
      return 'Nog op locatie';
    }
    return 'Afvoermelding ontbreekt';
  }

  public aanvoerLabel(status: VerblijfAanvoerStatus, plaats: RvoVerblijfPlaats): string {
    if (status === 'ok') {
      return formatRvoDisplayDate(plaats.aanvoerDatumME);
    }
    return 'Aanvoermelding ontbreekt';
  }

  public mapFallbackAddress(plaats: RvoVerblijfPlaats): string | null {
    return formatVerblijfAddress(plaats);
  }
}
